import { Icono, type NombreIcono } from '../ui/Icono';
import { useRuta } from '../../lib/ruta';

export interface EntradaMenu {
  id: string;
  etiqueta: string;
  corta?: string;
  icono: NombreIcono;
}

export const GRUPOS_MENU: { titulo: string; entradas: EntradaMenu[] }[] = [
  {
    titulo: 'Cada día',
    entradas: [
      { id: 'inicio', etiqueta: 'Inicio', icono: 'home' },
      { id: 'bandeja', etiqueta: 'Bandeja de entrada', icono: 'inbox' },
      { id: 'suenos', etiqueta: 'Sueños', icono: 'moon' },
      { id: 'diario', etiqueta: 'Diario emocional', corta: 'Diario', icono: 'heart' },
      { id: 'notas', etiqueta: 'Notas destacadas', icono: 'star' }
    ]
  },
  {
    titulo: 'Aprender',
    entradas: [
      { id: 'biblioteca', etiqueta: 'Biblioteca', icono: 'book' },
      { id: 'cursos', etiqueta: 'Cursos y ejercicios', icono: 'leaf' }
    ]
  },
  {
    titulo: 'Explorar',
    entradas: [
      { id: 'astrologia', etiqueta: 'Astrología', icono: 'orbit' },
      { id: 'reflexiones', etiqueta: 'Reflexiones con IA', icono: 'spark' },
      { id: 'libre', etiqueta: 'Espacio libre', icono: 'folder' }
    ]
  }
];

export const rutaDe = (id: string) => (id === 'inicio' ? '/' : '/' + id);

const EN_MAS = ['notas', 'biblioteca', 'cursos', 'astrologia', 'reflexiones', 'libre', 'mas', 'bandeja'];

export function Marca() {
  return (
    <div className="brand">
      <span className="brand-mark"><Icono nombre="leaf" /></span>
      <span>Mi Universo Interior</span>
    </div>
  );
}

export function AvisoPrivacidad() {
  return (
    <div className="privacy">
      <Icono nombre="lock" tam="sm" />
      <span>Contenidos terapéuticos: fuera de la primera versión y nunca incluidos en la IA general.</span>
    </div>
  );
}

function BotonTema({ oscuro, alternar, compacto }: { oscuro: boolean; alternar: () => void; compacto?: boolean }) {
  const etiqueta = oscuro ? 'Modo claro' : 'Modo oscuro';
  const icono: NombreIcono = oscuro ? 'sun' : 'moon';
  return compacto ? (
    <button className="btn icon quiet" aria-label={etiqueta} onClick={alternar}><Icono nombre={icono} /></button>
  ) : (
    <button className="btn" onClick={alternar}><Icono nombre={icono} />{etiqueta}</button>
  );
}

export function MenuLateral({ modulo, oscuro, alternarTema }: { modulo: string; oscuro: boolean; alternarTema: () => void }) {
  const { ir } = useRuta();
  return (
    <nav className="side" aria-label="Navegación principal">
      <div style={{ padding: '0 8px' }}><Marca /></div>
      {GRUPOS_MENU.map((g) => (
        <div key={g.titulo}>
          <p className="nav-title">{g.titulo}</p>
          {g.entradas.map((e) => (
            <button
              key={e.id}
              className={modulo === e.id ? 'nav-item on' : 'nav-item'}
              aria-current={modulo === e.id ? 'page' : undefined}
              onClick={() => ir(rutaDe(e.id))}
            >
              <Icono nombre={e.icono} /><span>{e.etiqueta}</span>
            </button>
          ))}
        </div>
      ))}
      <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <AvisoPrivacidad />
        <BotonTema oscuro={oscuro} alternar={alternarTema} />
      </div>
    </nav>
  );
}

export function CabeceraMovil({ oscuro, alternarTema }: { oscuro: boolean; alternarTema: () => void }) {
  return (
    <div className="mhead">
      <Marca />
      <BotonTema oscuro={oscuro} alternar={alternarTema} compacto />
    </div>
  );
}

export function BarraInferior({ modulo }: { modulo: string }) {
  const { ir } = useRuta();
  const boton = (id: string, etiqueta: string, icono: NombreIcono) => {
    const activo = id === 'mas' ? EN_MAS.includes(modulo) : modulo === id;
    return (
      <button className={activo ? 'bnav on' : 'bnav'} aria-current={activo ? 'page' : undefined} onClick={() => ir(rutaDe(id))}>
        <Icono nombre={icono} />{etiqueta}
      </button>
    );
  };
  return (
    <nav className="bottom" aria-label="Navegación inferior">
      {boton('inicio', 'Inicio', 'home')}
      {boton('suenos', 'Sueños', 'moon')}
      <div className="fab-wrap">
        <button className="fab" aria-label="Capturar en la bandeja" onClick={() => ir('/bandeja')}><Icono nombre="plus" tam="lg" /></button>
        <span>Capturar</span>
      </div>
      {boton('diario', 'Diario', 'heart')}
      {boton('mas', 'Más', 'grid')}
    </nav>
  );
}
